import { apiDelete, apiGet, apiPost, apiPut } from "./api";

export type MappingItem = {
  CreatedDate: string;
  DeviceId: string;
  EmpCode: string;
  LastModifiedDate: string;
  OrgId: string;
  Id: string;
};

export type MappingItemPayload = {
  DeviceId: string;
  EmpCode: string;
  Id: string;
};

export type ImportBody = {
  items: MappingItemPayload[];
};

const BASE_URL = "/lanscope-settings";

export const getMappingItems = async (
  params: any = {},
): Promise<MappingItem[]> => {
  return (await apiGet(BASE_URL, params)) as Promise<MappingItem[]>;
};

export const createMappingItem = async (
  item: MappingItemPayload,
): Promise<MappingItem> => {
  return (await apiPost(BASE_URL, item)) as Promise<MappingItem>;
};

export const updateMappingItem = async (
  item: MappingItemPayload,
): Promise<MappingItem> => {
  return (await apiPut(BASE_URL, item)) as Promise<MappingItem>;
};

export const deleteMappingItem = async (Id: string): Promise<any> => {
  return await apiDelete(`${BASE_URL}/${Id}`);
};

export const importMappingItem = async (body: ImportBody): Promise<any> => {
  return (await apiPost(`${BASE_URL}/import-batch`, body)) as Promise<any>;
};
